import { render } from "./sound.vue?vue&type=template&id=b9ee17e2&scoped=true"
const script = {}

import "./sound.vue?vue&type=style&index=0&id=b9ee17e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b9ee17e2"

export default script